import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import DatePicker from 'react-datepicker';
import {
   Calendar,
} from 'react-feather';
import { Input, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import withInputErrorMessage from '../withInputErrorMessage';
import withDateInput from './withDateInput';
import withOnChangeAsNonEvent from './withOnChangeAsNonEvent';
import withUseEffectErrorMessage from './withUseEffectErrorMessage';

const CustomDateInput = forwardRef(
   (props, ref) => {
      return (
         <InputGroup onClick={props?.onClick}>
            <Input
               {
                  ...props
               }
               placeholder={props.disabled ? '' : 'mm/dd/yyyy'}
               innerRef={ref}
            />
            <InputGroupAddon addonType='append'>
               <InputGroupText><Calendar size={18} strokeWidth={1.45}/></InputGroupText>
            </InputGroupAddon>
         </InputGroup>
      );
   },
);

const DateInput = (props) => {
   return (
      <DatePicker
         onBlur={props.onBlur}
         selected={props.value}
         disabled={props.isDisabled}
         dateFormat='MM/dd/yyyy'
         customInput={<CustomDateInput/>}
         onChange={props.onChange}
         name={props.name}
         minDate={props.minDate}
         className={props.className}
      />
   );
};

DateInput.propTypes = {
   value: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
   isDisabled: PropTypes.bool,
   onChange: PropTypes.func.isRequired,
   onBlur: PropTypes.func,
   name: PropTypes.string.isRequired,
   minDate: PropTypes.instanceOf(Date),
   className: PropTypes.string,
};

DateInput.defaultProps = {
   value: undefined,
   isDisabled: false,
   onBlur: undefined,
   minDate: undefined,
   className: '',
};

export default withOnChangeAsNonEvent(withUseEffectErrorMessage(withDateInput(withInputErrorMessage(DateInput))));
